module.exports = __webpack_public_path__ + "img/self_publisher.719cf344.svg";